import { createContext, useContext } from "react";

export const GuideTourContext = createContext({ openAtStep: () => {} });

export const useGuideTour = () => useContext(GuideTourContext);
